import React from "react";
import { LinearProgress, Tooltip, linearProgressClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "components/CustomButtons/Button.js";
import { WifiIcon } from "components/WifiIcon/WifiIcon";
import GiotankIcon from "assets/img/giotank.png";
import { BLUE_RGB } from "utils/colorsTheme";
import { ColumnContainer, ImageGiotank, BarPercent, BarContainer } from "./styles";

const BorderLinearProgress = styled(LinearProgress)({
  height: 18,
  borderRadius: 10,
  width: "100%",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#EEEEEE",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: BLUE_RGB,
  },
});

const headerStyle = {
  fontSize: ".875rem",
  fontWeight: "bold",
  color: BLUE_RGB,
};

const includesFilter = (value, filter) =>
  !!value?.toString().toLowerCase().includes(filter.value.toLowerCase());

const equalsFilter = (value, filter) =>
  String(value || 0).toLowerCase() === filter.value.toLowerCase();

const PercentCell = ({ value }) => (
  <BarContainer>
    <BarPercent>{value}%</BarPercent>
    <BorderLinearProgress variant="determinate" value={value} />
  </BarContainer>
);

const configTable = [
  {
    Header: "Dispositivo",
    accessor: "giotank.serialNumber",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["giotank.serialNumber"], filter),
  },
  {
    Header: "Cliente",
    accessor: "customer.name",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["customer.name"], filter),
  },
  {
    Header: "Cuenta",
    accessor: "customer.code",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["customer.code"], filter),
  },
  {
    Header: "Instalación",
    accessor: "giotank.date",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["giotank.date"], filter),
  },
  {
    Header: "Ultimo Surtido",
    accessor: "giotank.lastEvent.date",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["giotank.lastEvent.date"], filter),
  },
];

export const getColumns = (onOpenGraph) => [
  ...configTable,
  {
    Header: "% Gas",
    accessor: "giotank.lastEvent.gas",
    filterable: true,
    filterMethod: (filter, row) => equalsFilter(row["giotank.lastEvent.gas"], filter),
    Cell: ({ original }) => <PercentCell value={original.giotank?.lastEvent?.gas ?? 0} />,
  },
  {
    Header: "% Bateria",
    accessor: "giotank.lastEvent.battery",
    filterable: true,
    filterMethod: (filter, row) => equalsFilter(row["giotank.lastEvent.battery"], filter),
    Cell: ({ original }) => <PercentCell value={original.giotank?.lastEvent?.battery ?? 0} />,
  },
  {
    Header: "Nivel Señal",
    accessor: "giotank.lastEvent.signalLevel",
    filterable: true,
    filterMethod: (filter, row) => equalsFilter(row["giotank.lastEvent.signalLevel"], filter),
    Cell: ({ original }) => (
      <ColumnContainer justify="center">
        <WifiIcon signalLevel={original.giotank?.lastEvent?.signalLevel ?? 0} />
      </ColumnContainer>
    ),
  },
  {
    Header: "Estado",
    accessor: "giotank.lastEvent.status",
    filterable: true,
    filterMethod: (filter, row) => includesFilter(row["giotank.lastEvent.status"], filter),
  },
  {
    Header: "Acciones",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({ original }) => {
      const { giotank } = original;
      return (
        <ColumnContainer>
          <Tooltip id="tooltip-top" title="Graficas de giotank" placement="top">
            <Button
              justIcon
              simple
              round
              size="sm"
              onClick={() => onOpenGraph(giotank)}
              color="info"
              className="edit"
            >
              <ImageGiotank src={GiotankIcon} alt="Icono de giotank" />
            </Button>
          </Tooltip>
        </ColumnContainer>
      );
    },
  },
].map((col) => ({ ...col, headerStyle }));
